import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = {};
const NO_RETRY = /\/(auth\/|customer\/(login|register|refresh|logout|forgot-password|reset-password))/;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const url = cfg?.url || "";
    if (error.response?.status === 401 && !cfg._retry && !NO_RETRY.test(url)) {
      cfg._retry = true;
      const path = url.startsWith("/customer") ? "/customer/refresh" : "/auth/refresh";
      try {
        refreshing[path] = refreshing[path] || api.post(path);
        await refreshing[path];
        refreshing[path] = null;
        return api(cfg);
      } catch (e) {
        refreshing[path] = null;
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e, fallback = "حصلت مشكلة، جرب تاني") {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ") || fallback;
  return d.msg || fallback;
}
